export default state => state.orderSummary.basketItems;
